<template>
  <div class="zone" v-loading="exporting" :element-loading-text="loadingText">
    <functionBox  :titleData="{permission_flag:'SparePart',nowID:1}"  :notes="notes ? notes : ''" :hideSearchBtn = true
                  @searchBtn="searchBtn"   @clearSearch="clearSearch" :searhLoading="loading">
      <template>
        <li>
          <el-input placeholder="请输入关键字" v-model="searchParams.keywords" clearable size="small"></el-input>
        </li>
        <li>
          <el-date-picker
              size="small"
              v-model="search_time"
              format="yyyy/MM/dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="marginLeft:10px"
              class="Calendar"
              @clear="clearSearchTime"
          />
        </li>
        <li>
          <el-button type="primary" size="mini" @click="searchBtn">搜索</el-button>
        </li>
        <div  class="right" style="margin-top: 10px;text-align: right;">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAddTrain"   style="text-align: right; background: #1acb64;border:#1acb64">新增培训</el-button>
        </div>
      </template>
    </functionBox>
    <div class="sheet"  v-loading="loading" :element-loading-text="loadingText" style="background: #fff;padding:12px;">
      <el-table :data="tableData" stripe  :height="tableSize== 'big' ? '960' : tableSize== 'middle' ?'630' : '430'" >
        <el-table-column type="index" width="55" label="#"> </el-table-column>
        <el-table-column prop="title" label="培训项目" width="220" align="center"></el-table-column>
        <el-table-column prop="media_cover_image" label="培训图片"  min-width="150" align="center">
          <template v-slot="{row}">
            <img v-if="row.media_cover_image" :src="row.media_cover_image" style="width: 60px;height: 45px;">
          </template>
        </el-table-column>
        <el-table-column prop="participants_count" label="参加人数"  min-width="100" align="center"></el-table-column>
        <el-table-column prop="start_time" label="培训开始时间"  min-width="120" align="center">
          <template v-slot="{row}">
            <span>{{row.start_time.slice(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="end_time" label="培训结束时间"  min-width="120" align="center">
          <template v-slot="{row}">
            <span>{{row.end_time.slice(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" :width="tableSize== 'big' ? '650' : tableSize== 'middle' ?'500' : '400'" align="left" header-align="center" fixed="right">
          <template v-slot="{row}">
            <el-button size="mini"  @click="handleEdit('1',row)" v-if="isShowEdit(row)" class="train-edit-btn">编辑</el-button>
            <el-button size="mini" @click="addPeople(row)"  v-if="isAfterTargetDate(row)" class="train-add-btn">添加参与培训人员</el-button>
            <el-button size="mini" @click="handleCheck(row)"  class="train-check-btn">查看人员学习情况</el-button>
            <el-button size="mini"  @click="handleDelete(row)" v-if="isShowEdit(row)" class="train-delete-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="el_pagination_style">
        <el-pagination
            :hide-on-single-page="total <= 0"
            background
            layout="total,sizes,prev, pager, next,jumper"
            :total="total"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="size"
            :current-page.sync="page"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        />
      </div>

      <el-dialog
          :title="this.dtlId ? '修改培训信息' :'新增培训信息'"
          :visible="true"
          v-if="addTrainDialog"
          :modal="true"
          width="70%"
          min-height="500px"
          top="50px"
          @close="closeConfirm"
      >
        <add-train-dialog @closeDialog="closeConfirm" ref="addTrain" :dtl-id="dtlId"  @getIsSubmit="getIsSubmit" :rowData="selectedRows"></add-train-dialog>
        <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :disabled="!isSubmit" @click="confirmSubmit()" type="primary" size="small">确认提交</el-button>
        <el-button @click="closeConfirm" size="small">关闭页面</el-button>
      </span>
      </el-dialog>
      <el-dialog
          title="新增人员信息"
          :visible="true"
          v-if="addPeopleDialog"
          width="60%"
          min-height="500px"
          top="50px"
          @close="closePeople"
      >
        <select-trainer :tree-data="orgData" :dtl-id="dtlId"  :selected-ids="participants"   @selected="handleSelect"
                        v-model="selectedIds"></select-trainer>
        <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :disabled="!isSubmit" @click="saveParticipants()" type="primary" size="small">确认提交</el-button>
        <el-button @click="closePeople" size="small">关闭页面</el-button>
      </span>
      </el-dialog>
      <el-dialog
          title="删除确认"
          :visible="true"
          v-if="deltDialogVisible"
          width="50%"
          @close="deltDialogVisible=  false"
      >
        <span>确认要删除【{{training_name}}】培训任务吗？删除后，将不可恢复！</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmDelete(deleteId)">确 定</el-button>
          <el-button @click="deltDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
          title="学习情况汇总"
          :visible.sync="ellectDialog"

          width="80%"
          @close="ellectDialog=  false"
      >
        <ellect-dialog :dtl-id="dtlId"></ellect-dialog>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmCheck">确认</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TJDetailTitle from '@/components/TJDetailTitle'
import timePicker from '@/components/timePicker'
import FunctionBox from '@/views/Statistics/components/functionBox.vue'
import {addMenu, getAssetMgtBtn} from "@/router/menuMain";
import {getToken} from "@/utils/auth";
import addTrainDialog from "@/views/cloudTraining/training/components/addTrainDialog.vue";
import ellectDialog from "@/views/cloudTraining/training/components/ellectDialog.vue";
import {addParticipants, chooseTrainer, deleteTraining, getTrainingDtl, getTrainingList} from "@/api/training";
import selectTrainer from "@/views/cloudTraining/training/components/selectTrainer.vue";

export default {
  components: {selectTrainer , TJDetailTitle, timePicker, FunctionBox,addTrainDialog,ellectDialog},
  name: 'trainingList',  // 资产管理列表

  data() {
    return {
      deleteId: null,
      dtlId: '',
      userRoleId: JSON.parse(localStorage.getItem('userInfo')).org_post,
      confirmDialog: false,
      addTrainDialog: false,
      addPeopleDialog: false,
      deltDialogVisible: false,
      ellectDialog: false,
      fileList: [],
      training_name: '',
      participants: [],
      assetMGtObj:{
        checkExport: false, //盘点导出
      },
      isSubmit:true,
      tableSize: '',
      user_id: '',
      page: 1,
      size: 10,
      total: 0,
      notes: '',
      exporting: false, //加载动画
      loading: false, //加载动画
      tableData: [],
      search_time: [],
      selectedNotes: [],
      selectedList: [],
      selectedRows: [],
      is_export: false,
      tableHeight: 0,
      searchType: '0',
      message: '',
      searchParams:{
        keywords: '',
        start_time: '',
        end_time: '',
      },
      pageParams:{
        page: 1,
        size:10,
      },
      loadingText: '数据加载中，请稍后'
    }
  },
  created() {
    this.chooseTrainer()
    this.getTableHeight()
    let menuList = JSON.parse(localStorage.getItem('menuList'))
    addMenu(menuList);
    this.assetMGtObj = getAssetMgtBtn()// 缓存里取按钮权限
    this.getList()
    this.user_id = JSON.parse(localStorage.getItem("userInfo")).user_id
    if(window.innerWidth<1550){
      this.tableSize = 'small'
    }else if(window.innerWidth < 2400 && window.innerWidth > 1550){
      this.tableSize = 'middle'
    }else{
      this.tableSize = 'big'
    }

  },
  methods: {
    //判断当前时间是否在培训结束日期之后，如果是不显示参加培训人员按钮
    isAfterTargetDate(row) {
      const today = new Date().toISOString().slice(0, 10);
      const end_time = row.end_time.trim();
      if(today <= end_time) {
        return true;
      }else{
        return false;
      }
    },
    isShowEdit(row){
      const isAfterTargetDate = () => {
        const dateStr = row.start_time.trim();
        const target = new Date(dateStr);

        // 可选：校验是否有效日期
        if (isNaN(target.getTime())) {
          return false;
        }

        return new Date() < target;
      };
      return isAfterTargetDate()
    },
    addParticipants,
    chooseTrainer(){
      chooseTrainer().then(res=>{
        this.orgData = res.data
      })
    },
    handleAddTrain(){
      this.dtlId = ''
      this.addTrainDialog = true
    },
    getTableHeight(){
      var viewportHeight = window.innerHeight;
      var viewportWidth =  window.innerWidth
      // var element = document.getElementById('pagination');
      if(viewportWidth > 2400){
        this.tableHeight = viewportHeight - 500
      }else if(viewportWidth < 2400 &&  viewportWidth > 1550){
        this.tableHeight = viewportHeight - 400
      }else{
        this.tableHeight = viewportHeight - 600
      }
    },
    getList(){
      this.loading = true
      this.loadingText = '数据加载中，请稍后'
      if(this.searchType != '1' ){   //searchType = '0' 从详情返回的时候，需要获取缓存的搜索条件
        if(sessionStorage.getItem('AcPageParams')){
          this.pageParams = JSON.parse(sessionStorage.getItem('AcPageParams')).pageParams
          this.size = this.pageParams.size || 10
          this.page=this.pageParams.page || 1
        }
        if(JSON.parse(sessionStorage.getItem('TrainSearchParams'))){
          this.searchParams = {...JSON.parse(sessionStorage.getItem('TrainSearchParams')).searchParams};
          if(this.searchParams && this.searchParams.start_time && this.searchParams.end_time){
            this.search_time = [this.searchParams.start_time,this.searchParams.end_time]
          }else{
            this.search_time = []
          }
        }
      }
      if(this.search_time && this.search_time.length>0){
        this.searchParams.end_time = this.search_time[1]
        this.searchParams.start_time = this.search_time[0]
      }else{
        this.searchParams.end_time = ''
        this.searchParams.start_time = ''
      }
      let params = {
        ...this.searchParams,
        page:  this.pageParams.page,
        size: this.pageParams.size
      }
      getTrainingList(params).then(res=>{
        this.total = res.data.count
        this.tableData = res.data.data
        this.loading = false
      }).catch(err =>{
        this.loading = false
        if( err.status === 'error' && this.searchParams.page >1 ){
          this.searchParams.page--
          this.getList()
        }
      })
    },
    handlePlatSelect(val){
      this.platform_id = val
    },
    searchBtn() {  // 搜索
      this.page = 1
      if(this.search_time){
        this.searchParams.start_time = this.search_time[0]
        this.searchParams.end_time = this.search_time[1]
      }else{
        this.searchParams.start_time = ''
        this.searchParams.end_time = ''
      }
      this.searchType = '1'
      this.getList();
      sessionStorage.setItem('TrainSearchParams', JSON.stringify({ searchParams:this.searchParams }));
      sessionStorage.setItem('TrainSearchParams', JSON.stringify({ pageParams:{page: 1,size:10} }));
    },
    handleCurrentChange(val) { // 翻页
      this.page = val
      this.pageParams.size = this.size
      this.pageParams.page = this.page
      sessionStorage.setItem('TrainSearchParams', JSON.stringify({ pageParams:this.pageParams }));
      this.getList('1')
    },
    clearSearch(){  // 重置
      sessionStorage.setItem('TrainSearchParams', JSON.stringify({ searchParams:{}}));
      this.searchParams.keywords = ''
      this.searchParams.start_time = ''
      this.searchParams.end_time = ''
      this.search_time = []
      this.getList('1');

    },
    clearSearchTime(){
      this.searchParams.start_time = ''
      this.searchParams.end_time = ''
      this.check_time = []
      this.getList();
    },
    handleDelete(row){
      this.deltDialogVisible = true
      this.deleteId = row.training_id
      this.training_name=row.title
    },
    confirmDelete(id){
      // const h = this.$createElement
      // this.$confirm('提示', {
      //   title: '确认删除',
      //   message: h('div', [h('p', `确认要删除【培训项目培训项目培训项目培训项目】培训任务吗？删除后，将不可恢复！`),]),
      //   cancelButtonText: '取消',
      //   confirmButtonText: '确定',
      // }).then(() => {
        deleteTraining({id:id}).then(res=>{
          if(res.code == 200){
            this.$message.success('删除成功！')
            this.deltDialogVisible = false
            this.getList()
          }
        })
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消确认',
      //   })
      // })
    },
    handleSizeChange(val){
      this.pageParams.size = val
      this.pageParams.page = this.page
      sessionStorage.setItem('TrainPageParams', JSON.stringify({ pageParams:this.pageParams }));
      this.getList('1');
    },
    handleEdit(type,row){ //编辑
      this.dtlId = row.training_id
      // getTrainingDtl({id:this.dtlId}).then(res => {
      //   this.form = res.data.data
      // })
      setTimeout(()=>{
        this.addTrainDialog = true
      },500)
    },
    editCheck(type,row) {

    },
    getIsSubmit(){

    },
    confirmSubmit(){ //新增修改培训提交

      this.$refs.addTrain.handleSubmit()
    },
    addPeople(row){ //新增人员
      this.dtlId = row.training_id
      this.addPeopleDialog = true
      getTrainingDtl({id:this.dtlId}).then(res => {

        this.participants = res.data.participants
      })
    },
    closePeople(){
      this.participants = []
      this.addPeopleDialog = false
    },
    handleClose(){
      this.addTrainDialog = false
    },
    closeConfirm(){
      this.addTrainDialog =false
      setTimeout(()=>{
        this.getList()
      },1000)

    },
    handleCheck(row){ //查看学习情况
      this.dtlId = row.training_id
      setTimeout(()=>{
        this.ellectDialog = true
      },500)

    },
    confirmCheck(){
      this.ellectDialog = false
      // this.dtlId = ''
    },
    handleSelect(data){ //选择参训人员
      this.participants = data
    },
    saveParticipants(){ //保存参训人员
      this.participants = this.participants.map(Number)
      addParticipants({training_id:this.dtlId,participants_ids:this.participants}).then(res=>{
        this.$message.success('保存成功！')
        this.addPeopleDialog = false
        this.getList()
        this.participants = []
      })
    }

  },
}
</script>

<style scoped lang="scss">
@import '@/assets/css/asset';
::v-deep .el-table th:first-child.el-table__cell>.cell{
  padding-left:14px!important;
}
::v-deep .el-pagination__sizes{
  width: 80px;
  vertical-align: top;
}
::v-deep .el-pagination__sizes .el-select{
  vertical-align: top;
}
::v-deep .el-pagination__sizes input{
  width: 80px;
  height: 1.8rem;
  border: 1px solid #999999;
}
::v-deep .el-pagination .el-input__suffix{
  right: 22px;
}
::v-deep .el-range-editor--small .el-range-input{
  font-size: 0.75rem!important;
}
::v-deep .el-dialog__header{
  margin: 0 20px;
  border-bottom: 1px solid #eee;
}
.train-edit-btn{
  background: #fff;
  border:1px solid #4787F0;
  color: #4787F0;
}
.train-add-btn{
  background: #fff;
  border:1px solid #F2995F;
  color: #F2995F;
}
.train-check-btn{
  background: #fff;
  border:1px solid #81B337;
  color: #81B337;
}
.train-delete-btn{
  background: #fff;
  border:1px solid #BD3124;
  color: #BD3124;
}
::v-deep .el-dialog__footer{
  text-align: center;
}

</style>
